import { Grid, FormControl, TextField, Skeleton } from '@mui/material';
import { useContext } from 'react';
import { InvoiceDetailsContext, InvoiceDetailsValues } from '../contexts/InvoicesContext';
import InvoiceDetailsTable from './InvoiceDetailsTable';
import { Section } from '../../../components/ui/Section';

const InvoiceDetailsFields = () => {
  const { t, data, invoiceNote, changeInvoiceNote, isLoading } = useContext(InvoiceDetailsContext) as InvoiceDetailsValues;

  if (isLoading) {
    return <Skeleton variant='rectangular'
      sx={{ borderRadius: '12px' }}
      width='100%'
      height={1600} />;
  }

  return <>
    <Grid item
      container
      spacing={5}
      lg={9}
      xs={12}>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField label={t('orderNumber')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.orderNumber ?? ''} />
        </FormControl>
      </Grid>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField
            label={t('invoiceDate')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.invoiceDate?.split('T')[0] ?? ''} />
        </FormControl>
      </Grid>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField
            label={t('deliveryDate')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.deliveryDate?.split('T')[0] ?? ''} />
        </FormControl>
      </Grid>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField label={t('invoiceValue')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.invoiceValue ?? ''} />
        </FormControl>
      </Grid>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField label={t('vatValue')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.vatValue ?? ''} />
        </FormControl>
      </Grid>
      <Grid item
        lg={4}
        sm={6}
        xs={12}>
        <FormControl fullWidth>
          <TextField label={t('invoiceTotal')}
            disabled
            InputLabelProps={{ shrink: true }}
            value={data?.invoiceTotal ?? ''} />
        </FormControl>
      </Grid>
    </Grid>
    <Grid item
      lg={3}
      xs={12}>
      <FormControl fullWidth>
        <TextField multiline
          InputLabelProps={{ shrink: true }}
          minRows={3}
          label={t('note')}
          onChange={changeInvoiceNote}
          value={invoiceNote} />
      </FormControl>
    </Grid>
    <Grid item
      xs={12}>
      <Section>
        <InvoiceDetailsTable />
      </Section>
    </Grid>
  </>;
};

export default InvoiceDetailsFields;